"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import { ensureAuthSession, probeAuthSession } from "@/lib/auth/refresh-client";
import {
  isAdminExternalPath,
  isAdminInternalPath,
} from "@/lib/admin/admin-path";

const PROBE_INTERVAL_MS = 60 * 1000;

export function SiteSessionKeepalive() {
  const pathname = usePathname();

  useEffect(() => {

    if (
      pathname.startsWith("/member") ||
      isAdminExternalPath(pathname) ||
      isAdminInternalPath(pathname)
    ) {
      return;
    }

    let cancelled = false;
    let timer: number | undefined;

    async function start() {

      const probe = await probeAuthSession("member");

      if (cancelled || !probe.ok) {
        return;
      }

      timer = window.setInterval(() => {
        void ensureAuthSession("member");
      }, PROBE_INTERVAL_MS);
    }

    void start();

    function handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        void ensureAuthSession("member");
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      cancelled = true;
      if (timer) {
        window.clearInterval(timer);
      }
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [pathname]);

  return null;
}
